import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'submit'];
  static values = { max: { type: Number, default: 30 } };

  connect() {
    this.toast = null;
    this.validate();
  }

  validate() {
    let hasError = false;

    this.inputTargets.forEach((input) => {
      if (input.readOnly) return;

      const len = input.value.replace(/^[\s\u3000]+|[\s\u3000]+$/g, '').length;
      if (len > this.maxValue) {
        input.classList.add('name-length-error');
        hasError = true;
      } else {
        input.classList.remove('name-length-error');
      }
    });

    this.submitTarget.disabled = hasError;
    this.toggleToast(hasError);
  }

  toggleToast(show) {
    if (show) {
      if (!this.toast) {
        this.toast = document.createElement('div');
        this.toast.className = 'name-length-toast';
        this.toast.textContent = `項目名は${this.maxValue}文字以内にしてください`;
        document.body.appendChild(this.toast);
      }
    } else if (this.toast) {
      this.toast.remove();
      this.toast = null;
    }
  }

  disconnect() {
    if (this.toast) {
      this.toast.remove();
      this.toast = null;
    }
  }
}
